import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import CustomizedDialogs from "../details";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

const OpenCardDetail = ({ boardId: activeBoardId, cardsOnBoard = [], card }) => {
  const [showDetails, setShowDetails] = useState(true);
  const [searchParams] = useSearchParams();
  const { id } = useBoardIdByKey();
  const cardId = searchParams.get("card_id") || card;
  const boardId = activeBoardId || id;

  useEffect(() => {
    setShowDetails(Boolean(cardId));
  }, [cardId]);

  return (
    <div>
      {cardId && cardsOnBoard && (
        <CustomizedDialogs
          cardId={cardId}
          boardId={boardId}
          cardsOfSameWorkflowStepId={cardsOnBoard}
          showDetails={showDetails}
          setShowDetails={setShowDetails}
        />
      )}
    </div>
  );
};

export default OpenCardDetail;
